import { xLotteryConfig, xProceeds } from "../web3/Types";

export class LotteryConfig {
  numberPool: bigint;
  starPool: bigint;
  numbersPerTicket: bigint;
  starsPerTicket: bigint;
  prizeFundDistribution: PrizeFund[];
  revenueDistribution: RevenueDistribution;
  ticketPrice: bigint;
  ticketLimitTotal: bigint;
  ticketLimitPerPurchase: bigint;

  constructor(
    numberPool: bigint,
    starPool: bigint,
    numberAmount: bigint,
    starAmount: bigint,
    prizeFundDistribution: PrizeFund[],
    revenueDistribution: RevenueDistribution,
    ticketPrice: bigint,
    ticketLimit: bigint,
    ticketLimitPerPurchase: bigint,
  ) {
    this.numberPool = numberPool;
    this.starPool = starPool;
    this.numbersPerTicket = numberAmount;
    this.starsPerTicket = starAmount;
    this.prizeFundDistribution = prizeFundDistribution;
    this.revenueDistribution = revenueDistribution;
    this.ticketPrice = ticketPrice;
    this.ticketLimitTotal = ticketLimit;
    this.ticketLimitPerPurchase = ticketLimitPerPurchase;
  }

  // static empty(): LotteryConfig {
  //   return new LotteryConfig(
  //     0n,
  //     0n,
  //     0n,
  //     0n,
  //     [],
  //     0,
  //     RevenueDistribution.empty(),
  //     0n,
  //     0n,
  //     0n
  //   );
  // }

  static fromLotteryConfig(event: xLotteryConfig): LotteryConfig {
    const prizeFundDistribution: PrizeFund[] = event.tierAllocations.map(
      (prizeFund) =>
        new PrizeFund(
          Number(prizeFund.tier.mainNumbers),
          Number(prizeFund.tier.luckyStars),
          RevenueDistribution.weiToNumber(prizeFund.cut),
        ),
    );
    return new LotteryConfig(
      event.pools.mainNumbers,
      event.pools.luckyStars,
      event.jackpotTier.mainNumbers,
      event.jackpotTier.luckyStars,
      prizeFundDistribution,
      RevenueDistribution.from(event.proceedsAllocation),
      event.ticketPrice,
      event.ticketTotalLimit,
      event.ticketBuyLimit,
    );
  }

  toString(): string {
    return `LotteryConfig(numberPool: ${this.numberPool}, starPool: ${this.starPool}, numberAmount: ${this.numbersPerTicket}, starAmount: ${this.starsPerTicket}, revenueDistribution: ${this.revenueDistribution}, ticketPrice: ${this.ticketPrice}, ticketLimit: ${this.ticketLimitTotal}, ticketLimitPerPurchase: ${this.ticketLimitPerPurchase}, prizeFundDistribution: [${this.prizeFundDistribution.map((p) => p.toString()).join(", ")}])`;
  }
}

export class PrizeFund {
  numberAmount: number;
  starAmount: number;
  proportion: number;

  constructor(numberAmount: number, starAmount: number, proportion: number) {
    this.numberAmount = numberAmount;
    this.starAmount = starAmount;
    this.proportion = proportion;
  }

  toString(): string {
    return `PrizeFund(numberAmount: ${this.numberAmount}, starAmount: ${this.starAmount}, proportion: ${this.proportion})`;
  }
}

export class RevenueDistribution {
  charityCut: number;
  royaltyCut: number;

  constructor(charityCut: bigint, royaltyCut: bigint) {
    this.charityCut = RevenueDistribution.weiToNumber(charityCut);
    this.royaltyCut = RevenueDistribution.weiToNumber(royaltyCut);
  }

  static weiToNumber(wei: bigint) {
    return Number(wei) / 1e18;
  }

  static empty(): RevenueDistribution {
    return new RevenueDistribution(0n, 0n);
  }

  static from(event: xProceeds): RevenueDistribution {
    return new RevenueDistribution(event.donations, event.royalties);
  }

  toString(): string {
    return `RevenueDistribution(charityCut: ${this.charityCut}, royaltyCut: ${this.royaltyCut})`;
  }
}
